export const ERRORS: TError[] = [
    { code: 'CEU-01', message: 'El correo o teléfono ya se encuentran registrados.' },
    { code: 'CEU-02', message: 'Télefono no verificado.' },
    { code: 'CEC-01', message: 'Error 01 - Por favor, contacta a soporte.' },
    { code: 'CEC-02', message: 'Error 02 - Por favor, contacta a soporte.' },
    { code: 'CEC-03', message: 'Error 03 - Por favor, contacta a soporte.' },
    { code: 'CEC-04', message: 'Puntos insuficientes, elige otra cantidad.' },
    { code: 'CEC-05', message: 'Horario elegido no disponible.' },
    { code: 'CEC-06', message: 'Tipo de entrega no disponible en esta sucursal.' },
    { code: 'CEP-01', message: 'Pago no procesado, vuelve a intentar.' },
    { code: 'CEB-01', message: 'Algo ocurrió, contacta a soporte.' }
];

export type TError = {
    code: string;
    message: string;
};
